module.exports = __webpack_public_path__ + "media/components/page-quote/components/quote-info/progress-icon-3-41cec8d7c533cdf5c2bd2abcdfe783e6.svg";